// 根据当前语言返回产品分类名称。
// 接口同时返回中英文字段；历史数据尚未填写英文时回退中文，避免页面出现空白。
export function getCategoryDisplayName(category, locale) {
  if (!category) return "";

  const chineseName = category.name || category.categoryName || "";
  const englishName =
    category.nameEn ||
    category.name_en ||
    category.categoryNameEn ||
    category.category_name_en ||
    "";
  const isEnglish = String(locale || "")
    .toLowerCase()
    .startsWith("en");

  return isEnglish
    ? englishName || chineseName
    : chineseName || englishName;
}
